module.exports = __webpack_public_path__ + "static/land-rover-series-3-galvanised-chassis-032ee48e1258169dc5feeb8c5ff322a3.jpg";